import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllListDescription(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Description,
      queryString: `page=${page}&size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdDescription(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Description,
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllDescription(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Description,
      action: "GetAllDescrition"
    }, id);
    return await firstValueFrom(observable);
  }

  async createDescription(createDescription: any) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Description,
    }, {
      title:createDescription.title,
      content:createDescription.description,
      type:createDescription.type,
      isActive:createDescription.isActive
    });
    return await firstValueFrom(observable)
  }

  
  async updateDescription(updateDescription: any) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Description,
    }, {
      id:updateDescription.id,
      title:updateDescription.title,
      content:updateDescription.description,
      type:updateDescription.type,
      isActive:updateDescription.isActive
    });
    return await firstValueFrom(observable)
  }
}
